<template>
    <div>
        <md-card class="col-sm-12 col-md-6" v-if="vacancies.length > 0 && !loading" v-for="vacancy in vacancies"
                 :key="vacancy.key">
            <md-card-header>
                <div class="md-title">{{vacancy.title}}</div>
                <div class="md-subhead">{{vacancy.name}}, {{days[vacancy.day - 1]}}</div>
            </md-card-header>
            <md-card-content v-html="vacancy.text"></md-card-content>
            <md-card-actions>
                <a :href="'mailto:' + vacancy.email">
                    <md-button class="md-accent">Neem contact op</md-button>
                </a>
            </md-card-actions>
        </md-card>
        <div v-if="vacancies.length <= 0 && !loading">
            <empty-view title="Geen vacatures" text="Er zijn op dit moment geen vacatures beschikbaar. Zodra een markt vacatures toevoegt zullen deze hier getoond worden."/>
        </div>

        <div class="loading" v-if="loading" style="margin-top: 2.4rem;">
            <div class="spinner" style="top: 40%;"></div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import firebase from 'firebase';
    import moment from 'moment';
    import EmptyView from '@/components/empty/EmptyView';

    require("firebase/firestore");

    @Component
    export default class VacanciesPage extends Vue {

        loading = true;

        empty = false;

        vacancies = [];

        markets = {};

        days = [
            'Maandag',
            'Dinsdag',
            'Woensdag',
            'Donderdag',
            'Vrijdag',
            'Zaterdag',
            'Zondag'
        ];

        mounted() {
            this.fetch();
        }

        fetch() {
            console.log('[ Vacancies ]', 'Fetching vacancies...');
            this.loading = true;

            firebase.firestore().collection('vacancies')
              .where('visible', '==', true)
              .get()
              .then((querySnapshot) => {
                  if (querySnapshot.empty) {
                      //TODO show empty state
                      console.log('[ Vacancies ]', 'No vacancies found.');
                      this.loading = false;
                      this.vacancies = [];
                  } else {
                      querySnapshot.forEach((doc) => {
                          var vacancy = doc.data();
                          vacancy.key = doc.id;

                          //Fetch market information for every vacancy
                          firebase.firestore().doc(`markets/${vacancy.marketKey}`)
                            .get()
                            .then((m) => {
                                if (doc.exists) {
                                    var market = m.data();

                                    //Set market name and city for every vacancy
                                    vacancy.name = market.name;
                                    vacancy.city = market.city;

                                    this.loading = false;
                                    this.vacancies.push(vacancy);

                                    console.log('[ Vacancies ]', 'Found vacancy', vacancy);
                                } else {
                                    console.log('[ Vacancies ]', 'Market could not be found.',);
                                }
                            }, (err) => {
                                console.warn('[ Vacancies ]', err);
                            });
                      });
                  }
              })
              .catch(function (error) {
                  console.log('[ Vacancies ]', "Error getting vacancies: ", error);
              });
        }
    }

    Vue.component('vacancies-page', VacanciesPage);
</script>

<style src="./styles.scss" lang="scss" scoped></style>




// WEBPACK FOOTER //
// src/pages/vacancies/VacanciesPage.vue